export default __webpack_public_path__ + "static/work-paladins-6c8aa7e3c941bd11ed5f7c6829d3fde3.jpg";